import React from "react";
import { useTranslation } from "react-i18next"; // ✅ Correct import
import Bg from "./../assets/Images/bg/1.png";
import Button from "./../components/ui/Button";
import ButtomShadow from "./../assets/elements/shadowbuttom.png";
import { useNavigate } from "react-router-dom";

const HomeSection: React.FC = () => {
  const { t } = useTranslation(); // ✅ Remove explicit type (same as Header.tsx)
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <img src={Bg} alt="Background" style={styles.backgroundImage} />

      <div style={styles.overlay}>
        <h1 style={styles.title}>{t("home_title")}</h1>
        <p style={styles.subtitle}>{t("home_subtitle")}</p> 
        <p style={styles.description}>{t("home_description")}</p>

        <div style={styles.btncontainer}>
          <Button variant="white" width="190px" onClick={() => navigate("/programs")}>
            {t("home_button")}
          </Button>
        </div>
      </div>

      <div style={styles.shadowContainer}>
        <img src={ButtomShadow} alt="Bottom Shadow" style={styles.shadowImage} />
      </div>
    </div>
  );
};
 

const styles = {
  btncontainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  container: {
    width: "100%",
    height: "85vh",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    color: "#fff",
    margin: 0,
    padding: 0,
  } as React.CSSProperties,
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1,
  } as React.CSSProperties,
  overlay: {
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center" as const,
    width: "80%",
    maxWidth: "650px",
    zIndex: 1,
  } as React.CSSProperties,
  title: {
    fontFamily: "var(--title-font)", 
    fontSize: "52px",
    margin: "35px 0 35px",
    fontWeight: "400",
  } as React.CSSProperties,
  subtitle: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "18px",
    textAlign: "center",
  } as React.CSSProperties,
  description: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "center",
    color: "#fff",
    opacity: 0.7,
    margin: "10px 0 30px 0",
  } as React.CSSProperties,
  shadowContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    zIndex: 0,
  } as React.CSSProperties,
  shadowImage: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
  } as React.CSSProperties,
};

export default HomeSection;
